import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import {
  MENU_CONFIG,
  getCurrentUserRole,
  hasAccess,
} from "../../common/roleConfig";

//i18n
import { withTranslation } from "react-i18next";
import { getBrandColor } from "../../theme";

const SidebarContent = (props) => {
  const ref = useRef();
  const [userRole] = useState(getCurrentUserRole());


  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (
          pathName === items[i].pathname ||
          "/" + pathName.split("/")[1] + ("/" + pathName.split("/")[2]) ===
            items[i].pathname
        ) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    if (ref.current) {
      ref.current.recalculate();
    }
  }, []);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  const history = useHistory();
  const handleLogout = (e) => {
    e.preventDefault();
    const brand = getBrandColor();
    Swal.fire({
      title: props.t("Are you sure you want to Logout?"),
      customClass: {
        popup: "my-swal-popup",
      },
      showCancelButton: true,
      confirmButtonColor: brand,
      cancelButtonColor: "#d33",
      confirmButtonText: props.t("Yes, Logout it!"),
      cancelButtonText: props.t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        history.push("/logout");
      }
    });
  };

  const renderMenuItem = (item) => {
    if (!hasAccess(item, userRole)) return null;

    return (
      <li key={item.path}>
        <Link to={item.path}>
          <i className={item.icon}></i>
          <span>{props.t(item.label)}</span>
        </Link>
      </li>
    );
  };

  const renderSubMenu = (menuItem) => {
    if (!hasAccess(menuItem, userRole)) return null;

    return (
      <li key={menuItem.label}>
        <Link to="/#" className="has-arrow">
          <i className={menuItem.icon}></i>
          <span>{props.t(menuItem.label)}</span>
        </Link>
        <ul className="sub-menu">
          {Object.values(menuItem.items).map((subItem) => (
            <li key={subItem.path}>
              <Link to={subItem.path}>{props.t(subItem.label)}</Link>
            </li>
          ))}
        </ul>
      </li>
    );
  };

  const renderMenuSection = (section) => {
    if (!section.items || Object.keys(section.items).length === 0) return null;

    // For SUPER_ADMIN, show all sections
    if (userRole === "0") {
      return (
        <React.Fragment key={section.title}>
          <li className="menu-title">
            <i className="bx bx-buoy font-size-12"></i> {props.t(section.title)}{" "}
          </li>
          {Object.values(section.items).map((item) =>
            item.type === "submenu" ? renderSubMenu(item) : renderMenuItem(item)
          )}
        </React.Fragment>
      );
    }

    // For other roles, check access
    const hasAccessibleItems = Object.values(section.items).some((item) =>
      hasAccess(item, userRole)
    );

    if (!hasAccessibleItems) return null;

    return (
      <React.Fragment key={section.title}>
        <li className="menu-title">
          <i className="bx bx-buoy font-size-12"></i> {props.t(section.title)}{" "}
        </li>
        {Object.values(section.items).map((item) =>
          item.type === "submenu" ? renderSubMenu(item) : renderMenuItem(item)
        )}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">
              <i className="bx bx-buoy font-size-12"></i> {props.t("Dashboard")}{" "}
            </li>
            {renderMenuItem(MENU_CONFIG.dashboard)}

            {Object.entries(MENU_CONFIG)
              .filter(([key]) => key !== "dashboard")
              .map(([_, section]) => renderMenuSection(section))}

            <li className="menu-title">
              <i className="bx bx-buoy font-size-12"></i> {props.t("Logout")}
            </li>
            <li>
              <Link onClick={handleLogout} className="" to={"/"}>
                <i className="bx bx-power-off"></i>
                <span>{props.t("Logout")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
